import { FC } from "react"

export const Heading : FC<{text:string}> = ({text}) => {

    return (
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{text}</h2>
    )
}